import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpService } from './http.service';


const initFilter = {
  company: { type: 'all', id: null },
  time: '3M',
}

@Injectable({
  providedIn: 'root'
})
export class SubNavbarService {

  private filter$ = new BehaviorSubject<any>(initFilter);

  constructor(private httpSvc: HttpService) { }

  get selectedFilter$() {
    return this.filter$.asObservable();
  }

  setFilter(newFilter: any) {
    this.filter$.next(newFilter)
  }

  getAllCompanies() {
    return this.httpSvc.get('/company/all-companies')
  }

  generateExcelReport(id: any, timeFilter: any, companyId: any) {
    let filtro = [];
    if (timeFilter) filtro.push(`time=${timeFilter}`);
    if (companyId) filtro.push(`companyId=${companyId}`);
    return this.httpSvc.get(`/report/kpi-report/${id}?${filtro.join('&')}`);
  }
}
